import Repo from './Repo.js'

export default class VacationRequestRepository extends Repo {
  constructor () {
    super('vacation-requests')
  }

  all (q) {
    return super.all(q)
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
      return super.paginate(q)
  }

  search (data) {
    return this.http.get(this.resource + '/search', data).then((response) => {
        return Promise.resolve(response)
    }).catch((response) => {
        return Promise.reject(response)
    })
   }

    searchAndExport (data, name = "Used Vacations") {
        data.export = 1;
        return this.http.download(this.resource + '/search', data).then((response) => {
            let blob = new Blob([response.data], { type:   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' } );
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = name+'.xlsx';
            link.click();
            return Promise.resolve(response);
        }).catch((response) => {
            return Promise.reject(response)
        })
    }

  maxDate(data) {
      return this.http.get(this.resource + '/max/date', data).then((response) => {
          return Promise.resolve(response)
      }).catch((response) => {
          return Promise.reject(response)
      })
  }

  calcDuration(data) {
    return this.http.get(this.resource + '/calc', data).then((response) => {
        return Promise.resolve(response)
    }).catch((response) => {
        return Promise.reject(response)
    })
  }

  pdf (id, name = "Decision") {
    return this.http.download(this.resource + "/" + id + "/pdf").then((response) => {
        let blob = new Blob([response.data], { type:   'application/pdf' } );
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = name+'.pdf';
        link.click();
        return Promise.resolve(response);
    }).catch((response) =>{
            return Promise.reject(response);
    });
  }

    requestPdf (id, name = "Request") {
        return this.http.download(this.resource + "/" + id + "/pdf/request").then((response) => {
            let blob = new Blob([response.data], { type:   'application/pdf' } );
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = name+'.pdf';
        link.click();
        return Promise.resolve(response);
    }).catch((response) =>{
            return Promise.reject(response);
    });
    }

  process(id, data) {
    return this.http.post(this.resource + '/' + id + '/process', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
        return Promise.reject(response)
    })
  }
}
